export default __webpack_public_path__ + "static/media/Happybellmerge.cfbdad24.mp3";